export function jsonEq<T>(one: T, another: T) {
  return JSON.stringify(one) === JSON.stringify(another);
}

export function jsonEqNonNullable<T>(one: NonNullable<T>, another: NonNullable<T>) {
  return JSON.stringify(one) === JSON.stringify(another);
}
